<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>DiCentral Service</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>

    <main id="cont">
      <div id="overview" class="subCon">
        <section class="platform3 inner_box">
          <h3 class="con_tit">
            귀사에 필요한 DiCentral의 제품을 자세히 알아보세요
          </h3>

          <ul class="clearfix">
            <li>
              <v-img
                src="@/assets/img/dicentral/ediservice/scm.jpg"
                alt=""
                style="height: 224.34px"
              />
              <dl>
                <dt>SCM</dt>
                <dd>
                  <ul>
                    <li>
                      DiCentral의 독점 ERP 어댑터는 EDI 클라우드 플랫폼과<br />
                      함께 작동하여 100개 이상의 ERP, WMS 및 회계 시스템과
                      통합되도록 설계되어 있습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
              <router-link to="/dicentral/ediService">More view</router-link>
            </li>
            <li>
              <v-img
                src="@/assets/img/dicentral/ediservice/webedi.jpg"
                alt=""
                style="height: 224.34px"
              />
              <dl>
                <dt>Web EDI</dt>
                <dd>
                  <ul>
                    <li>
                      DiCentral의 클라우드 기반 EDI 솔루션을 사용하면<br />
                      소프트웨어나 하드웨어에 투자할 필요가 없고<br />
                      비즈니스 확장 시 문서 이력관리를 신속하게 자동화 하여<br />
                      백-오피스 시스템과 통합할 수 있습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
              <router-link to="/dicentral/ediservice#web">
                More view</router-link
              >
            </li>

            <li>
              <v-img
                src="@/assets/img/dicentral/ediservice/3pl.jpg"
                alt=""
                style="height: 224.34px"
              />
              <dl>
                <dt>3PL</dt>
                <dd>
                  <ul>
                    <li>
                      창고의 공간 관리 및 픽앤팩(Pick-and-pack)<br />
                      재고관리 서비스를 확장하여 보다 신속하고 정확하게 고객의
                      요구사항을 충족할 수 있습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
              <router-link to="/dicentral/ediservice#s3pl"
                >More view</router-link
              >
            </li>
          </ul>
          <ul class="clearfix">
            <li
              style="
                float: left;
                position: relative;
                width: 41.66%;
                margin: 0 2.5% 93px 7%;
                padding-bottom: 61px;
              "
            >
              <v-img
                src="@/assets/img/dicentral/ediservice/integrate.jpg"
                alt=""
              />
              <dl>
                <dt>Integrate</dt>
                <dd>
                  <ul>
                    <li>
                      DiCentral의 독점 ERP 어댑터는<br />
                      EDI 클라우드 플랫폼과 함께 작동하여 100개 이상의 ERP,
                      WMS<br />
                      및 회계 시스템과 통합되도록 설계되어 있습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
              <router-link to="/dicentral/ediservice#integrate"
                >More view</router-link
              >
            </li>

            <li
              style="
                float: left;
                position: relative;
                width: 41.66%;
                margin: 0 5% 93px 0;
                padding-bottom: 61px;
              "
            >
              <v-img
                src="@/assets/img/dicentral/ediservice/automotive.jpg"
                alt=""
              />
              <dl>
                <dt>Automotive</dt>
                <dd>
                  <ul>
                    <li>
                      자동차 제조업에 특화된 Automotive는<br />
                      아시아, 유럽 및 미주 전역에서 25년 간 사용한<br />
                      자동차 전문 EDI 노하우를 사용하여 귀사의 업무 효율을
                      높이세요.
                    </li>
                  </ul>
                </dd>
              </dl>
              <router-link to="/dicentral/ediservice#auto"
                >More view</router-link
              >
            </li>
          </ul>
        </section>
        <!-- .platform3 -->
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
